import * as dataActions from './dataActions'
import * as generalActions from './generalActions'
import * as receiptActions from './receiptActions'
import * as resource from '../constants/Resources';

export function hasRight(rightId, showMessage) {
    return function (dispatch, getState) {
        let result = false;

        const managerId = getState().generalState.tempRights;
        const user = managerId> 0? 
            dispatch(dataActions.getSystemUser(managerId)): 
            dispatch(dataActions.getSystemUser(getState().loginState.loggedin.id));
            
        if (user !== null) {
            for (let i = 0; i < user.Rights.length; i++) {
                if (user.Rights[i] === rightId) {
                    result = true;
                    break;
                }
            }
        }

        if (!result && showMessage) {
            dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_RIGHTS))));
        }

        if(getState().generalState.tempRights > 0)
        {
            var action = "";
            
            switch(rightId)
            {
                case 2001: action="Print Z rapport"; break;
                case 2002: action="Print X rapport"; break;
                case 2003: action="Retour"; break;
                case 2004: action="Cancel receiptline"; break;
                case 2005: action="Cancel receipt"; break;
                case 2006: action="Open drawer"; break;
                default: break;
            }

            dispatch(receiptActions.saveHistoryStep(action));
        }

        

        return result;
    }
}


// WEBPACK FOOTER //
// src/actions/rightsActions.js